<script>
import Layout from "../../layouts/main";
import Style from "@/views/layouts/style";
import PageHeader from "@/components/Page-header";
import appConfig from "@/../app.config";
import trainingAPI from "@/services/standards/preventionbrigade/trainingAPI";
import CheckModal from "@/components/CheckModal";
import ItemAPI from "@/services/items/itemsAPI";

/**
 * Form elements component
 */
export default {
  page: {
    title: "5.1.2 Brigada de emergencias",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: {
    Layout,
    Style,
    CheckModal,
    PageHeader,
  },
  data() {
    return {
      title: "5.1.2 Brigada de emergencias",
      items: [
        {
          text: "Estándares",
          href: "/forms/estandares",
        },
        {
          text: "5.1.2 Brigada de emergencias",
          active: true,
        },
      ],

      classificationID: this.$store.getters["company/getCompany"].company_classification_id || null,
      userSelected: null,
      usersList: [],
      itemData: null,
      loading1: true,
      training: {
        id: null,
        title: null,
        video: null,
        description: null,
        status: null,
      },
      videoI: null,
    };
  },
  methods: {

    getItemData() {
      ItemAPI.getItems(52)
        .then((response) => {
          this.itemData = response;
        })
        .catch((error) => {
          console.log(error);
        });
    },

    allowAccess() {
      try {
        const item = this.itemData;

        if (item) {
          const classificationID =
            this.$store.getters["company/getCompany"].company_classification_id || null;

          if (classificationID === 1 && item.obligatory_UPA === 1) {
            return true;
          } else if (classificationID === 2 && item.obligatory_groupI === 1) {
            return true;
          } else if (classificationID === 3 && item.obligatory_groupII === 1) {
            return true;
          } else if (classificationID === 4 && item.obligatory_groupIII === 1) {
            return true;
          } else {
            return false;
          }
        } else {
          return false;
        }
      } catch (error) {
        console.log(error);
        return false;
      }
    },


    /**
   * This method is used to knows if the user has the permission indicated
   * @param {String} name The name of the permission
   * @param {Array} roles the roles that permitted to access the action 
   * @returns {Boolean} true if the user has the permission indicated or false if no
   */
    getRole(name, roles) {

      // Get the user role
      let role = this.$store.state.auth.info.role ? this.$store.state.auth.info.role : null

      // If the user is logged
      if (role) {

        // If the roles array is not empty
        if (roles) {

          // Know if the role indicated is in the roles array
          role = roles.includes(role) ? true : false

        } // Close if the roles arrays is not empty

        // If the roles arrays is empty
        else {

          // Know if the user role is in the roles indicated
          role = role === 1 || role === 2 || role === 3 || role === 4 || role === 5 || role === 6 || role === 7 || role === 8

        } // Close if the roles arrays is empty

        // Get the user permissions
        const permissions = this.$store.state.auth.info.permissions

        // Know if the user has the permission indicated
        const enabled = permissions.find(permission => permission.name === name)

        // If the user has the permission indicated and the user role is in the roles indicated
        return enabled && role ? true : false

      } // Close if the user is logged

      // If the user is not logged
      else {
        return false
      } // Close else the user is not logged
    },

    /**
   * This method is used to redirect to the page indicated
   * @param {String} page The page to redirect
   */
    goPage(page) {
      window.location.href = page
    },

    gettraining() {
      trainingAPI
        .getTraining(this.$route.params.id)
        .then((response) => {
          this.training = {
            id: response.id,
            title: response.title,
            video: response.video,
            description: response.description,
            status: response.status,
          };
          this.videoI = response.video;
          this.loading1 = false
        })
        .catch((error) => {
          console.log(error);
        });
    },

    goBack() {
      this.$router.go(-1);
    },
  },

  mounted() {
    this.gettraining()
    this.getItemData();
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" />

    <div class="row animated animatedFadeInUp fadeInUp">
      <div class="col-md-12">
        <div class="col-xl-12" v-if="!loading1">

          <div class="card">
            <div class="card-body">
              <div class="row">
                <div class="col-md-6 col-sm-12">

                  <CheckModal>
                    <p class="text-justify">
                      La empresa deberá realizar evaluaciones periódicas del estado de salud de sus colaboradores,
                      para esto se informa al médico que realiza las evaluaciones ocupacionales los perfiles del cargo,
                      con una descripción de las tareas y el medio en el cual se desarrollará la labor respectiva; esta
                      evaluación
                      deberá ser adelantada por médicos profesionales en medicina laboral.
                    </p>

                  </CheckModal>
                </div>

                <div class="col-6 text-right">
                  <div @click="goBack" class="btn btn-secondary m-l-5 ml-1" id="tooltip">
                    <i class="fas fa-arrow-left"></i>
                  </div>
                  <b-tooltip target="tooltip" placement="left">Volver</b-tooltip>
                </div>

              </div>

              <form class="form-group" @submit.prevent="update">
                <div class="form-row pt-3">

                  <b-form-group label-for="employee" class="col-md-6 px-2" label="Título">
                    <b-form-input disabled type="text" id="date_exam" v-model="training.title">
                    </b-form-input>
                  </b-form-group>

                  <b-form-group class="col-md-6" label="Estado" label-for="employee">
                    <select disabled id="employeeID" class="form-control" v-model="training.status">
                      <b-form-select-option value="1">
                        Activo
                      </b-form-select-option>
                      <b-form-select-option value="0">
                        Inactivo
                      </b-form-select-option>
                    </select>
                  </b-form-group>

                  <b-form-group class="col-md-12 px-2" label="Descripción" label-for="file">
                    <b-form-textarea disabled type="date" id="note" v-model="training.description">
                    </b-form-textarea>
                  </b-form-group>

                </div>

              </form>
            </div>
          </div>
        </div>

        <div v-else class="col-xl-12 text-center">
          <div class="text-center">
            <b-spinner variant="primary" label="Loading..."></b-spinner>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>
